import { HttpErrorResponse, HttpResponse } from "@angular/common/http";

export enum TramiteEstadoEnum {
    Eliminado = 0,
    EnCarrito = 1,
    FormularioPendiente = 2,
    FormularioCompleto = 3,
    PagoRealizado = 4,
    NoRequierePago = 5
}



/*===============================================================================================*/
/*Respuesta de la API para datos genericos ------------------------------------------------------*/
/*===============================================================================================*/



export interface ObtencionGenerica {
    [key: string]: any | string | number | boolean | null | undefined;
}

export interface ObtencionGenericaAnidada {
    [key: string]: ObtencionGenericaAnidada | string | number | boolean | null | undefined;
};

export interface ApiResponse_Error {
    code: number;
    message: string;
    details?: any;
}

export interface ApiResponse<T = any> {
    success: boolean;
    data?: T;
    error?: ApiResponse_Error;
}

export interface ApiResponse_ObtencionGenericaMany extends ApiResponse<ObtencionGenerica[]> {
    success: boolean;
    data?: ObtencionGenerica[];
    error?: ApiResponse_Error;
}

export interface ApiResponse_ObtencionGenericaSingle extends ApiResponse<ObtencionGenerica> {
    success: boolean;
    data?: ObtencionGenerica;
    error?: ApiResponse_Error;
}



// Builders handler para respuestas de la API -----------------------------------------------------



export function ApiResponse_handleSuccessResponse<T>(response: HttpResponse<T>): ApiResponse<T> {
    if (response.status >= 200 && response.status < 300 && response.body) {
        return {
            success: true,
            data: response.body
        };
    }

    return {
        success: false,
        error: {
            code: response.status,
            message: 'Error en la respuesta',
            details: 'La operación no se completó correctamente.'
        }
    };
}

export function ApiResponse_handleHttpError(error: HttpErrorResponse, customMessages: Partial<Record<number, { message: string; details?: string }>> = {}): ApiResponse_Error {
    const defaults: Record<number, { message: string; details?: string }> = {
        400: { message: 'Solicitud incorrecta', details: 'Verifica los datos enviados' },
        404: { message: 'No encontrado', details: 'No se encontró información' },
        500: { message: 'Error interno del servidor', details: 'Ocurrió un problema en el servidor' },
        401: { message: 'No autorizado', details: 'Inicia sesión nuevamente' },
        403: { message: 'Acceso denegado', details: 'No tienes permisos suficientes' }
    };

    const combined = { ...defaults, ...customMessages };

    const status = error.status in combined ? error.status : 0;
    const fallback = { message: 'Error desconocido', details: error.message };
    const config = combined[status] || fallback;

    return {
        code: error.status,
        message: config.message,
        details: error.error?.message || config.details || error.message
    };
}

export function ApiResponse_handleLabelValuesEmpty(data?: ObtencionGenerica, customMessaje?: ObtencionGenerica): ObtencionGenerica {
    if (data && Object.keys(data).length > 0) {
        return data;
    }

    // Si no hay datos, devolver un objeto con un mensaje de respuesta
    return customMessaje ? customMessaje : {
        Response: "Sin registros",
    };
}



/*===============================================================================================*/
/*Respuesta de la API para datos genericos ------------------------------------------------------*/
/*===============================================================================================*/
/** 
 * Estructura de datos que se mostrará en la vista de registro profesional
 * dentro de la tab de los datos de la solicitud.
 * 
 * Endpoint: /api/v1.0/registro-profesionales/solicitud/{idSolicitud}
 * 
 * */



export interface FieldLabelsServiceInterface {
    tipoPersona: string;
    nacionalidad: string;
    tipoDocumento: string;
    documento: string;
    nombreCompletoPersona: string;
    ambito: string;
    profesion: string;
    clasificacion: string;
    nivelAcademico: string;
    tituloObtenido: string;
    centroEstudio: string;
    fechaGraduacion: string;
    paisEstudio: string;
    carnetActual: string;
    fechaVencimientoCarnet: string;
    flujoTramite: string;
    solicitud: number;
    estado: string;
}

export const FieldLabelsService: ObtencionGenerica = {
    
    /* Informacion general */

    tipoPersona: 'Tipo de persona',
    nacionalidad: 'Nacionalidad',
    tipoDocumento: 'Tipo de documento',
    documento: 'Documento',
    nombreCompletoPersona: 'Nombre completo',

    /* Modalidad de registro */

    ambito: 'Ámbito de Registro',
    profesion: 'Profesión',
    clasificacion: 'Clasificación',

    /* Formacion academica */

    nivelAcademico: 'Nivel Académico',
    tituloObtenido: 'Título Obtenido',
    centroEstudio: 'Centro de Estudios',
    fechaGraduacion: 'Fecha de Graduación',
    paisEstudio: 'País de Estudio',
    carnetActual: 'Carnet Actual',
    fechaVencimientoCarnet: 'Fecha de Vencimiento',
    flujoTramite: 'Flujo de Trámite',
    solicitud: 'Número de Solicitud',
    estado: 'Estado'
};

export const FieldValuesService: FieldLabelsServiceInterface = {
    "tipoPersona": "",
    "nacionalidad": "",
    "tipoDocumento": "",
    "documento": "00000000-0",
    "nombreCompletoPersona": "",
    "ambito": "",
    "profesion": "",
    "clasificacion": "",
    "nivelAcademico": "",
    "tituloObtenido": "",
    "centroEstudio": "strng",
    "fechaGraduacion": "2000-01-01",
    "paisEstudio": "",
    "carnetActual": "",
    "fechaVencimientoCarnet": "2000-01-01",
    "flujoTramite": "",
    "solicitud": 0,
    "estado": ""
}

export const FieldGroups = [
    {
        title: 'Información general',
        fields: ['tipoPersona', 'nacionalidad', 'tipoDocumento', 'documento', 'nombreCompletoPersona']
    },
    {
        title: 'Modalidad de registro',
        fields: ['ambito', 'profesion', 'clasificacion']
    },
    {
        title: 'Formación académica',
        fields: ['nivelAcademico', 'tituloObtenido', 'centroEstudio', 'fechaGraduacion', 'paisEstudio']
    },
    {
        title: 'Carnet profesional',
        fields: ['carnetActual', 'fechaVencimientoCarnet']
    },
    {
        title: 'Datos del trámite',
        fields: ['flujoTramite', 'solicitud', 'estado']
    }
];


export interface FieldLabelsAntecedentesInterface {
    institucion: string;
    numDocumento: string;
    profesion: string;
    nombres: string;
    apellidos: string;
    nacionalidad: string;
    carnet: string;
    fechaOtorgamientoPermiso: string;
    fechaVencimientoPermiso: string;
}

export const FieldLabelsAntecedentes: ObtencionGenerica = {
    institucion: 'Institución',
    numDocumento: 'Número de Documento',
    profesion: 'Profesión',
    nombres: 'Nombres',
    apellidos: 'Apellidos',
    nacionalidad: 'Nacionalidad',
    carnet: 'Carnet',
    fechaOtorgamientoPermiso: 'Fecha de Otorgamiento del Permiso',
    fechaVencimientoPermiso: 'Fecha de Vencimiento del Permiso'
};

export const FieldValuesAntecedentes: FieldLabelsAntecedentesInterface = {
    "institucion": "",
    "numDocumento": "",
    "profesion": "",
    "nombres": "",
    "apellidos": "",
    "nacionalidad": "",
    "carnet": "",
    "fechaOtorgamientoPermiso": "2000-01-01",
    "fechaVencimientoPermiso": "2000-01-01"
}

export interface ActualizarFechasCarnetReq {
    idSolicitud: number;
    fechaPermiso?: string;
    fechaVencimiento: string;
}

export interface ActualizarFechasMigReq {
    numResolucion: string;
    numDocumento: string;
    fechaOtorgamientoPermiso: string;
    fechaVencimientoPermiso: string;
}